export default __webpack_public_path__ + "static/media/file.1f5fed20.svg";